export default __webpack_public_path__ + "static/caseStudy2-us-2615109d30bf909535676e89f5c289f2.webp";